import React, { FC, memo } from 'react'
import cn from 'classnames'
import CrossIcon from '../../../icons/cross.svg'
import { IBranch } from '../../../types/user'

interface ICartHeaderProps {
  branch: IBranch
  onNumberEdit: () => void
  onClose: () => void
}

const ShoppingCartHeader: FC<ICartHeaderProps> = ({
  branch,
  onNumberEdit,
  onClose,
}) => {
  return (
    <div className="order-modal_head" data-testid="cart-header">
      <div
        className="order-modal_head-number_branch form"
        data-testid="cart-branch"
      >
        {branch.name}
      </div>

      <div className="order-modal_head-number form">
        <div className="order-modal_title">Order -&nbsp;</div>
        <div
          className={cn('order-modal_number', { '-disabled': false })}
          onClick={onNumberEdit}
          data-testid="cart-po-number"
        >
          {branch.purchaseOrderNumber || 'Add PO Number'}
        </div>
        <button
          type="button"
          className="order-modal_back clear-button"
          onClick={onClose}
          data-testid="cart-close"
        >
          <CrossIcon width={15} height={16} />
        </button>
      </div>
    </div>
  )
}

export default memo(ShoppingCartHeader)
